import {Component} from '@angular/core';
import {
  AlertController,
  Events,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ViewController
} from 'ionic-angular';
import {ProfileAccountDetailsPage} from "../profile-account-details/profile-account-details";
import {ProfilePasswordPage} from "../profile-password/profile-password";
import {ProfileLoginPage} from "../profile-login/profile-login";
import {LobbyPage} from "../lobby/lobby";
import {LobbyDisplayPage} from "../lobby-display/lobby-display";

import {HttpClient} from '@angular/common/http';
import {Camera, CameraOptions} from '@ionic-native/camera';
import {AppVersion} from "@ionic-native/app-version";
import {PaymentsPage} from "../payments/payments";
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";
import {StaffDashboardPage} from "../staff-dashboard/staff-dashboard";
import {LoyaltyRewardsPage} from "../loyalty-rewards/loyalty-rewards";
import {TermsPage} from "../terms/terms";
import {ProfilePromoProductsPage} from "../profile-promo-products/profile-promo-products"
import { PromoProductsService } from '../../providers/promo-products/promo-products.service';
import { PromoProductHistory } from '../../interfaces/PromoProduct.interface';
import { FavouritesPage } from '../favourites/favourites';
import { BookingsHoursPage } from '../bookings-hours/bookings-hours';

@Component({
    selector: 'page-profile',
    templateUrl: 'profile.html',
    providers: [PromoProductsService]
})
export class ProfilePage {
    public accessToPromoProducts: boolean = false;
    public loadingPage: boolean = true;
    errors: {};
    loading: boolean;
    account: any;
    isStaff: boolean;
    imageData: any;

    isAdminForCurrentTeamId: boolean = false;

    appVersionNumber: any;
    appBuildNumber: any;

    constructor(
      public navParams: NavParams,
      public navCtrl: NavController,
      public events: Events,
      public modalCtrl: ModalController,
      private viewCtrl: ViewController,
      private camera: Camera,
      private http: HttpClient,
      private appVersion: AppVersion,
      private platform: Platform,
      private tabsService: TabsServiceProvider,
      private alertCtrl: AlertController,
      private promoProductsService: PromoProductsService
    ) {
    }

    async ionViewWillEnter() {
        this.tabsService.show();
        try {
          this.accessToPromoProducts = !!(await this.promoProductsService.getPromoProductsHistory(localStorage.getItem('tuid')).toPromise() as PromoProductHistory[]).length
        } catch(error) {
          console.log(error);
        }
        this.account = this.navParams.get('account');
        this.viewCtrl.showBackButton(false);
        this.account.initials = this.getInitials(this.account.name);
        this.isStaff = this.account.account_type === 1 || this.account.account_type === 3;
        this.isAdminForCurrentTeamId = this.checkIsAdminForCurrentTeamId();
        this.loadingPage = false;
        if (this.platform.is('cordova')) {
            if (this.platform.is('ios')) {
                this.appVersion.getVersionNumber().then(version => {
                    this.appVersionNumber = 'v' + version;
                }).then(()=>{
                    return this.appVersion.getVersionCode();
                }).then(version=>{
                    this.appBuildNumber = version;
                });
            }
            if (this.platform.is('android')) {
                this.appVersion.getVersionCode().then(version => {
                    this.appVersionNumber = 'v' + version;
                });
            }
        }
    }

    checkIsAdminForCurrentTeamId(){
      let currentTeamId = Number(localStorage.getItem('currentTeamId'));
      if (Array.isArray(this.account.is_admin_for_teams)){
        return this.account.is_admin_for_teams.includes(currentTeamId);
      }
      return false;
    }

    getInitials(name) {
      let parts = name.split(' ');
      let initials = '';

      for (let i = 0; i < parts.length; i++) {
          if (parts[i].length > 0 && parts[i] !== '') {
              initials += parts[i][0]
          }
      }
      return initials
    }

    logout() {

        let alert = this.alertCtrl.create({
          title: "Logout",
          subTitle: "Are you sure you want to logout?",
          enableBackdropDismiss: false,
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
              }
            },
            {
              text: 'Logout',
              handler: () => {

                // Clear all values when logging out
                localStorage.clear();
                // Create a login event
                localStorage.removeItem('stripeCustomerId');
                this.events.publish('user:logout');
                this.navCtrl.setRoot(ProfileLoginPage, {}, {animate: true});

              }
            }
          ]
        });
        alert.present();
    }

    openDetailsPage(event: any, account: object) {
        this.navCtrl.push(ProfileAccountDetailsPage, {
            account: account
        });
    }

    openPasswordResetPage(event: any, account: object) {
        this.navCtrl.push(ProfilePasswordPage, {
            account: account
        });
    }

    openLobbyPage() {
        let modal = this.modalCtrl.create(LobbyPage, '', {
            cssClass: 'lobby-modal full-screen',
        });

        modal.present();
    }

    openLobbyDisplayPage(event: any, account: object) {
        let modal = this.modalCtrl.create(LobbyDisplayPage, '', {
            cssClass: 'lobby-modal full-screen',
        });
        modal.present();
    }

    getImage() {

        const options: CameraOptions = {
            quality: 100,
            destinationType: this.camera.DestinationType.DATA_URL,
            sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
        };

        this.camera.getPicture(options).then((imageData) => {

            this.imageData = imageData;
            this.uploadImage();

        }, (err) => {
            console.log(err);
        });
    }

    uploadImage() {

        this.loading = true;

        this.http.post(`/user/${this.account.id}/profile-photo-upload`, {
            photo: this.imageData
        }).subscribe(
            (data: any) => {

                this.account.photo_url = data.photo_url;
                this.loading = false;

            }, error => {
                this.loading = false;
            });
    }

  openPaymentsPage() {
    this.navCtrl.push(PaymentsPage);
  }

  openFavouritesPage() {
    this.navCtrl.push(FavouritesPage);
  }

  openBookingsHoursPage() {
    this.navCtrl.push(BookingsHoursPage);
  }

  openStaffPage() {
    this.navCtrl.push(StaffDashboardPage);
  }

  openLoyaltyPage() {
    this.navCtrl.push(LoyaltyRewardsPage);
  }
  openTermsPage() {
    this.navCtrl.push(TermsPage);
  }
  openPromoProductPage() {
    this.navCtrl.push(ProfilePromoProductsPage);
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts